module.exports = __webpack_public_path__ + "img/zap-fast.261b60a4.svg";